import $ from 'cash-dom';
import { matchHover } from '../media';

/**
 * This module reveals text content of persons
 */
export class SpersonModule {

    static name = 'sperson';

    constructor(node) {

        node.personModule = this;

        this.node = $(node);
        this.inner = this.node.find('.sperson-inner');
        this.person = this.node.find('.sperson');

        this.isOpen = false;

        this.node.find('.sperson-plus').on('click', this.toggle);

        if(matchHover.matches) {
            this.person.on('mouseenter', this.open);
            this.person.on('mouseleave', this.close);
        } else {
            this.person.on('click', () => {
                if(!this.isOpen) this.open();
            });
        }
    }

    toggle = () => {
        if(!this.isOpen) {
            this.open();
        } else {
            this.close();
        }
    }

    open = () => {

        // close others
        $('.sperson-wrap.open').each(function() {
            this.personModule.close();
        })

        this.node.addClass('open');
        this.isOpen = true;
    }

    close = () => {

        this.person[0].addEventListener('transitionend', () => this.person.css('height', 'auto'), { once: true });

        this.node.removeClass('open');
        this.isOpen = false;
    }
}